import { useMemo } from 'react';
import Aux from '../components/hoc/auxiliary';
import parse from 'html-react-parser';
import { InlineMath, BlockMath } from "react-katex";
import reactStringReplace from 'react-string-replace';
export const ProcessedLessonWidgetTextMath = ({

    customClass,
    text

}) => {

    const getMath = t => {
        let newMathString = reactStringReplace(t, /\$\$([\s\S]*?)\$\$/gm, (match,i) => (
            <BlockMath math={match} errorColor={'#000000'}/>
        ))
      
        newMathString = reactStringReplace(newMathString, /\\\[([\s\S]*?)\\\]/gm, (match,i) => (
            <BlockMath math={match} errorColor={'#000000'}/>
        ))
    
        newMathString = reactStringReplace(newMathString, /\\\\\(([\s\S]*?)\\\\\)/gm, (match,i) => (
            <InlineMath math={match} errorColor={'#000000'}/>
        ))
    
        newMathString = reactStringReplace(newMathString, /\\\(([\s\S]*?)\\\)/gm, (match,i) => (
            <InlineMath math={match} errorColor={'#000000'}/>
        ))

        return newMathString

    }

    const newString = useMemo(() => getMath(text), [text])



    return(
      
  
        <div className={customClass} style={{whiteSpace: 'pre-line'}}>
        {newString.map((x,i)=> {
                return(
                    <Aux key={i}>
                        {typeof x === 'string'
                        ?
                        parse(x)
                        :
                        x
                        }

                    </Aux>

                )
            })}
        </div>
   
      
    )


}